import { render } from "./sider_menu.vue?vue&type=template&id=6e54a810"
import script from "./sider_menu.vue?vue&type=script&lang=js"
export * from "./sider_menu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__